var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import React, { useState, useCallback } from 'react';
import toast from '../toast';
import chooseImage from './chooseImage';
import Copper from './copper';
export const Upload = ({ children, action = '/kjy/mp/upload/image', disabled, onDone }) => {
    const [imgUrl, setImgUrl] = useState();
    const [visible, setVisible] = useState(false);
    const handleClick = useCallback(() => {
        var _a;
        const { onClick } = (_a = children) === null || _a === void 0 ? void 0 : _a.props;
        onClick && onClick();
        if (disabled) {
            return;
        }
        chooseImage({
            count: 1,
            success: (res) => {
                setImgUrl(res.tempFilePaths[0]);
                setVisible(true);
            }
        });
    }, [children, disabled]);
    const handleCancel = useCallback(() => {
        setVisible(false);
    }, []);
    const handleDone = useCallback((imgUrl) => __awaiter(void 0, void 0, void 0, function* () {
        if (process.env.NODE_ENV === 'development') {
            onDone &&
                onDone({
                    base64: imgUrl,
                    data: imgUrl
                });
            setVisible(false);
        }
        else {
            yield axios
                .post(action, {
                bucketName: 'duiba',
                base64: imgUrl
            })
                .then((res) => {
                onDone &&
                    onDone(Object.assign({ base64: imgUrl }, res.data));
                setVisible(false);
            })
                .catch((err) => {
                toast.error(err.message);
                setVisible(false);
            });
        }
    }), [action, onDone]);
    if (children) {
        return (React.createElement(React.Fragment, null,
            React.cloneElement(React.Children.only(children), {
                onClick: handleClick
            }),
            visible && imgUrl && React.createElement(Copper, { imgUrl: imgUrl, onCancel: handleCancel, onDone: handleDone })));
    }
    else {
        return null;
    }
};
export default Upload;
